import React, { useEffect, useRef, useState } from 'react';
import useGlobalVariables from '../../../hooks/useGlobalVariables';
import DateRangeQueryBuilderView from '../view/DateRangeQueryBuilderView';

const DateRangeQueryBuilderEngine = ({ query = [], update = () => {} }) => {
  const { setIsLoading } = useGlobalVariables();
  const [value, setValue] = useState('');
  const [value2, setValue2] = useState('');
  const [maxStartDateString, setMaxStartDateString] = useState('');
  const [minEndDateString, setMinEndDateString] = useState('');
  const [dateType, setDateType] = useState('');
  const skipUpdate = useRef(true);
  const initialized = useRef(false);

  useEffect(() => {
    let initialV1, initialV2, field, newDateType;
    if (initialized.current) {
      return;
    }
    initialized.current = true;
    try {
      if (query.length) {
        initialV1 = query[0].value || '';
        field = query[0].field || '';
        initialV2 = query[1] ? query[1].value : '';
        if (!initialV2) {
          initialV2 = '';
        }
        newDateType =
          field === `'metadata'->>'updatedDate'`
            ? 'updated'
            : field === `'statusData'->>'statusDate'`
            ? 'status'
            : field === `'submissionDate'`
            ? 'submission'
            : '';
        setDateType(newDateType);
        setValue(initialV1);
        setValue2(initialV2);
        setMaxStartDateString(initialV2);
        setMinEndDateString(initialV1);
      }
    } catch (e) {}
  }, [query]);

  useEffect(() => {
    const newQueryClauses = [];
    if (skipUpdate.current) {
      skipUpdate.current = false;
      return;
    }
    if (!dateType) {
      return;
    }
    const dateField =
      dateType === 'updated'
        ? "'metadata'->>'updatedDate'"
        : dateType === 'status'
        ? "'statusData'->>'statusDate'"
        : "'submissionDate'";
    if (value) {
      newQueryClauses.push({
        field: dateField,
        op: '>=',
        value: value,
        internOp: 'and',
        timeUnit: 'day'
      });
    }
    if (value2) {
      newQueryClauses.push({
        field: dateField,
        op: '<=',
        value: value2,
        internOp: 'and',
        timeUnit: 'day'
      });
    }
    if (
      newQueryClauses.length === 2 &&
      JSON.stringify(newQueryClauses) !== JSON.stringify(query)
    ) {
      setIsLoading(true);
      update(newQueryClauses);
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  }, [dateType, value, value2]);

  const parseDate = date => {
    let parsedDate = new Date(date);
    if (date === 'now') {
      return null;
    }

    if (!(parsedDate instanceof Date && !isNaN(parsedDate))) {
      parsedDate = new Date(parseInt(date));
    }
    return parsedDate;
  };
  const updateVal = (v, which) => {
    if (which) {
      setValue2(v);
      setMaxStartDateString(v);
    } else {
      setValue(v);
      setMinEndDateString(v);
    }
  };
  const viewProps = {
    dateType,
    maxStartDateString,
    minEndDateString,
    setDateType,
    parseDate,
    updateVal,
    value,
    value2,
    variant: null
  };

  return <DateRangeQueryBuilderView {...viewProps} />;
};

export default DateRangeQueryBuilderEngine;
